var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { CLOSE_REASONS, USER_INTENT } from "../lib/constants";
import { ContainerFull, FullWidthForm } from "./Styles/Styles";
import { clickedCloseButton, confirmCloseHidden } from "../lib/Avo";
import Button from "./connect-ui/Button";
import { PHASE } from "../routeConfig";
import { STICKY_STATE_DISABLED } from "../lib/features";
import { SURVEY_REASONS } from "../lib/TrellisAnalytics";
import classNames from "classnames";
import { toggleConfirmClose } from "../features/navigation/navigationSlice";
import useAppDispatch from "../hooks/useAppDispatch";
import useAppSelector from "../hooks/useAppSelector";
import useCanShowMidFunnelAds from "../features/configuration/useCanShowMidFunnelAds";
import useCloseClickHandler from "../hooks/useCloseClickHandler";
import useCloseHandler from "../hooks/useCloseHandler";
import useFeatureIsEnabled from "../hooks/useFeatureIsEnabled";
import { useHistory } from "react-router-dom";
import useRouteConfig from "../hooks/useRouteConfig";
function StyledText(_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return React.createElement("p", __assign({ className: classNames("text-center", className) }, rest));
}
function StandardCloseForm(_a) {
    var handleConfirmCloseHide = _a.handleConfirmCloseHide;
    var featureIsEnabled = useFeatureIsEnabled();
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var handleClose = useCloseHandler();
    var progressIsPersisted = featureIsEnabled(STICKY_STATE_DISABLED) === false;
    function handleCloseClick() {
        clickedCloseButton(__assign({}, commonAnalyticsProperties));
        handleClose({
            reason: CLOSE_REASONS.CLICKED_CLOSE_BUTTON,
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledText, { style: { fontSize: "20px" } }, "Are you sure you want to exit?"),
        React.createElement(Button, { type: "button", onClick: handleCloseClick }, "Yes, exit"),
        React.createElement(Button, { className: "mt-4", type: "button", onClick: handleConfirmCloseHide }, "No, continue"),
        !progressIsPersisted ? (React.createElement(StyledText, { style: { fontSize: "16px", lineHeight: "1.4em" } }, "Your progress will be lost and any unsubmitted credentials will be removed for security")) : null));
}
function OnCloseSurveyForm(_a) {
    var handleConfirmCloseHide = _a.handleConfirmCloseHide;
    var featureIsEnabled = useFeatureIsEnabled();
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var handleClose = useCloseHandler();
    var canShowMidFunnelAds = useCanShowMidFunnelAds();
    var handleCloseClick = useCloseClickHandler();
    var push = useHistory().push;
    var dispatch = useAppDispatch();
    var progressIsPersisted = featureIsEnabled(STICKY_STATE_DISABLED) === false;
    var trackSurveyResponse = function (reason) { return function () {
        clickedCloseButton(__assign({}, commonAnalyticsProperties));
        handleClose({ reason: reason });
    }; };
    function handleWillNotLinkAccount(closeReason) {
        if (canShowMidFunnelAds) {
            dispatch(toggleConfirmClose(false));
            push(PHASE.MID_FUNNEL_ADS);
        }
        else {
            handleCloseClick({
                reason: closeReason,
                userIntent: USER_INTENT.PROCEED_MANUALLY,
            });
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledText, { style: { fontSize: "20px" } }, "What went wrong?"),
        React.createElement(Button, { style: { marginTop: "16px" }, className: "submit pure-button pure-button-primary", type: "button", onClick: trackSurveyResponse(SURVEY_REASONS.CLOSE_SURVEY_DONT_KNOW) }, "Don't know my login"),
        React.createElement(Button, { style: { marginTop: "16px" }, className: "submit pure-button pure-button-primary", type: "button", onClick: function () {
                return handleWillNotLinkAccount(SURVEY_REASONS.CLOSE_SURVEY_DONT_WANT_TO);
            } }, "Don't want to use my login"),
        React.createElement(Button, { style: { marginTop: "16px" }, className: "submit pure-button pure-button-primary", type: "button", onClick: handleConfirmCloseHide }, "Go back"),
        !progressIsPersisted ? (React.createElement(StyledText, { style: { fontSize: "16px", lineHeight: "1.4em" } }, "If you leave your progress will be lost and any unsubmitted credentials will be removed for security")) : null));
}
export default function ConfirmClose() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var page = useRouteConfig().page;
    var dispatch = useAppDispatch();
    var backgroundColor = "#FFF";
    var SHOULD_SHOW_SURVEY = false;
    function handleConfirmCloseHide() {
        confirmCloseHidden(commonAnalyticsProperties);
        dispatch(toggleConfirmClose(false));
    }
    // https://trellisconnect.atlassian.net/browse/ENG-440
    // We don't need the survey anymore but we want to leave it in to easily
    // bring back in the future.
    return (React.createElement(ContainerFull, { style: { height: "100%", backgroundColor: backgroundColor } },
        React.createElement(FullWidthForm, { style: { justifyContent: "center" } }, page === "Credentials" && SHOULD_SHOW_SURVEY ? (React.createElement(OnCloseSurveyForm, { handleConfirmCloseHide: handleConfirmCloseHide })) : (React.createElement(StandardCloseForm, { handleConfirmCloseHide: handleConfirmCloseHide })))));
}
